import React from "react";
import styled from "styled-components";

import useNavigationCollapse from "../../../hooks/useNavigationCollapse";

type NavigationCollapsableProps = {
  className?: string;
};

const NavigationCollapseIcon: React.FC<NavigationCollapsableProps> = ({ className }) => {
  const { isCollapsed, toggleCollapse } = useNavigationCollapse();

  return (
    <Container
      className={className}
      onClick={toggleCollapse}
      title={isCollapsed ? "Open menu" : "Close menu"}
    >
      <StyledIcon className={isCollapsed ? "icon-ic-menu" : "icon-ic-arrow-left"} />
    </Container>
  );
};

export default NavigationCollapseIcon;

const Container = styled.div`
  width: 24px;
  height: 24px;
  background: ${({ theme }) => theme.colors.bg.primary};
  border-radius: 16px;
  cursor: pointer;
  border: 1px solid ${({ theme }) => theme.colors.bg.divider};
  box-sizing: border-box;
  display: flex;
  align-items: center;
`;

const StyledIcon = styled.i`
  font-size: 24px;
  color: ${({ theme }) => theme.colors.fg.tertiary};
  line-height: 24px;
  text-align: center;
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;

  ::before {
    margin-left: -1px;
  }
`;
